import { render } from "./ThanksPointMessage.vue?vue&type=template&id=e905d70e&scoped=true&ts=true"
import script from "./ThanksPointMessage.vue?vue&type=script&lang=ts"
export * from "./ThanksPointMessage.vue?vue&type=script&lang=ts"

import "./ThanksPointMessage.vue?vue&type=style&index=0&id=e905d70e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e905d70e"]])

export default __exports__